import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0A1128] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Description */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_drive-hub-27/artifacts/1glibbg5_logo%202.png" 
              alt="Motoring Daily" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-sm text-white/70 leading-relaxed">
              Your Premium Destination For Car Reviews, News, And Automotive Insights.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4">Quick Links</h3>
            <div className="flex flex-col space-y-2">
              <Link to="/" className="text-sm text-white/70 hover:text-[#00A859] transition-colors">
                Home
              </Link>
              <Link to="/news" className="text-sm text-white/70 hover:text-[#00A859] transition-colors">
                News
              </Link>
              <Link to="/reviews" className="text-sm text-white/70 hover:text-[#00A859] transition-colors">
                Reviews
              </Link>
              <Link to="/contact" className="text-sm text-white/70 hover:text-[#00A859] transition-colors">
                Contact
              </Link>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/motoring_daily/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-[#00A859] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@motoringdaily"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-[#00A859] transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-sm text-white/70">
            © 2025 Motoring Daily. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};